/* eslint-disable @nx/enforce-module-boundaries */
import {
  SubmissionTypes,
  ResponseRecord,
  SubmissionInfo,
  SessionStatusBot,
} from '@hyper-inferno/survey-elements-core';

export class SubmissionInfoBuilder {
  private _submissionType: SubmissionTypes = SubmissionTypes.CLIENT_RESPONSE;
  private _submissionPayload: ResponseRecord = {};
  private _statusChange?: SessionStatusBot;

  // --- Static Factory Methods ---

  /**
   * Returns a pre-configured builder for a standard Client Response.
   */
  static default(): SubmissionInfoBuilder {
    return new SubmissionInfoBuilder().setType(SubmissionTypes.CLIENT_RESPONSE);
  }

  /**
   * Returns a builder for a survey termination case.
   */
  static forTermination(reason?: string): SubmissionInfoBuilder {
    const builder = new SubmissionInfoBuilder()
      .setType(SubmissionTypes.BOT_TERMINATE_SURVEY_NO_REDIRECT)
      .setStatus(SessionStatusBot.TERMINATED);
    if (reason) builder.addPayloadEntry('reason', reason);
    return builder;
  }

  // --- Instance Methods ---

  setType(type: SubmissionTypes): this {
    this._submissionType = type;
    return this;
  }

  setPayload(payload: ResponseRecord): this {
    this._submissionPayload = payload;
    return this;
  }

  addPayloadEntry(key: string, value: string | number): this {
    this._submissionPayload[key] = value;
    return this;
  }

  setStatus(status: SessionStatusBot): this {
    this._statusChange = status;
    return this;
  }

  build(): SubmissionInfo {
    return {
      submissionType: this._submissionType,
      submissionPayload: this._submissionPayload,
      ...(this._statusChange && { statusChange: this._statusChange }),
    };
  }
}
